export default "__VITE_ASSET__7bae5d71__"